module.exports = __webpack_public_path__ + "static/img/mouth_05.92c0583.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/mouths/thumbnail/mouth_05.png
// module id = uwsE
// module chunks = 0